import { Component, OnInit } from '@angular/core';
import LocomotiveScroll from 'locomotive-scroll';

declare var carousel:any;
declare var scrollNav:any;
declare var splittext01: any;

@Component({
  selector: 'app-aviso-legal',
  templateUrl: './aviso-legal.component.html',
  styles: [
  ]
})
export class AvisoLegalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

    setTimeout(() => {

      const scroll = new LocomotiveScroll({
        el: document.querySelector('[data-scroll-container]'),
        smooth: true,
        smartphone: {
          smooth: false
          },
          tablet: {
          smooth: false
          },      
        getDirection: true
        
      });

      new splittext01();
      scrollNav()
      }, 250);
  }

}
